/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScoringHealthStateResponse } from './ScoringHealthStateResponse';
import {
    ScoringHealthStateResponseFromJSON,
    ScoringHealthStateResponseFromJSONTyped,
    ScoringHealthStateResponseToJSON,
    ScoringHealthStateResponseToJSONTyped,
} from './ScoringHealthStateResponse';
import type { ScoringHealthClientResponse } from './ScoringHealthClientResponse';
import {
    ScoringHealthClientResponseFromJSON,
    ScoringHealthClientResponseFromJSONTyped,
    ScoringHealthClientResponseToJSON,
    ScoringHealthClientResponseToJSONTyped,
} from './ScoringHealthClientResponse';
import type { ScoringHealthModeResponse } from './ScoringHealthModeResponse';
import {
    ScoringHealthModeResponseFromJSON,
    ScoringHealthModeResponseFromJSONTyped,
    ScoringHealthModeResponseToJSON,
    ScoringHealthModeResponseToJSONTyped,
} from './ScoringHealthModeResponse';

/**
 * 
 * @export
 * @interface ScoringHealthResponse
 */
export interface ScoringHealthResponse {
    /**
     * 
     * @type {ScoringHealthClientResponse}
     * @memberof ScoringHealthResponse
     */
    client: ScoringHealthClientResponse;
    /**
     * 
     * @type {ScoringHealthStateResponse}
     * @memberof ScoringHealthResponse
     */
    state: ScoringHealthStateResponse;
    /**
     * 
     * @type {ScoringHealthModeResponse}
     * @memberof ScoringHealthResponse
     */
    mode: ScoringHealthModeResponse;
    /**
     * Most recent gameplay ping from any client, epoch ms. Absent when none is live.
     * @type {number}
     * @memberof ScoringHealthResponse
     */
    lastSeenAt?: number;
}

/**
 * Check if a given object implements the ScoringHealthResponse interface.
 */
export function instanceOfScoringHealthResponse(value: object): value is ScoringHealthResponse {
    if (!('client' in value) || value['client'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('mode' in value) || value['mode'] === undefined) return false;
    return true;
}

export function ScoringHealthResponseFromJSON(json: any): ScoringHealthResponse {
    return ScoringHealthResponseFromJSONTyped(json, false);
}

export function ScoringHealthResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScoringHealthResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'client': ScoringHealthClientResponseFromJSON(json['client']),
        'state': ScoringHealthStateResponseFromJSON(json['state']),
        'mode': ScoringHealthModeResponseFromJSON(json['mode']),
        'lastSeenAt': json['lastSeenAt'] == null ? undefined : json['lastSeenAt'],
    };
}

export function ScoringHealthResponseToJSON(json: any): ScoringHealthResponse {
    return ScoringHealthResponseToJSONTyped(json, false);
}

export function ScoringHealthResponseToJSONTyped(value?: ScoringHealthResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'client': ScoringHealthClientResponseToJSON(value['client']),
        'state': ScoringHealthStateResponseToJSON(value['state']),
        'mode': ScoringHealthModeResponseToJSON(value['mode']),
        'lastSeenAt': value['lastSeenAt'],
    };
}

